import { render, staticRenderFns } from "./contect-menu.vue?vue&type=template&id=5cc79e3c"
import script from "./contect-menu.vue?vue&type=script&lang=js"
export * from "./contect-menu.vue?vue&type=script&lang=js"
import style0 from "./contect-menu.vue?vue&type=style&index=0&id=5cc79e3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports